import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../../context/ThemeContext";
import { closeOrder, closeOrderPosition, deleteSLTPOrders, getChartHistoryData, modifyOrder, updateSLTPOrders } from "../../api/request/dashboard/dashboard";
import { setGlobalSymbolID, setGlobalSymbolsData } from "../../store/Slices/globalSymbolSlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { addJournalLog } from "../tab/tabview/journal/addJournalLog";
import { getCookies } from "../../services/Cookies";
import { deleteOrdersData, deletePositionsData, editSLTPOrder } from "../../store/Slices/orderPositionSlice";

export const handlerMap = new Map();
export const channelToSubscription = new Map();

export const publishNewTick = (tick, symbolName, symbolId) => {
    try {
        const subscriptionItem = channelToSubscription.get(symbolId);
        const handler = handlerMap.get(symbolId);
        if (subscriptionItem === undefined) {
            return;
        }
        let bar;
        bar = {
            time: tick.ts,
            open: tick.bid,
            high: tick.bid,
            low: tick.bid,
            close: tick.bid,
        };
        handler.callback(bar);
    } catch (error) { }
};
const TradingViewChart = ({ symbolId }) => {
    const lastBarsCache = new Map();
    const lineInstance = new Map();
    const orderLineMap = new Map();
    const pendingOrderLineMap = new Map();
    const sltpLineMap = new Map();
    const chartContainerRef = useRef(null);
    const { userDetail } = useSelector(state => state.user)
    const configurationData = {
        supported_resolutions: ['1', '5', '15', '30', '60', '240', '1D', '1W', '1M'],
    };
    const { darkMode, direction } = useContext(ThemeContext)
    const { symbols } = useSelector(state => state?.watchlist)
    const { globalSymbol: defaultSymbol } = useSelector(state => state?.globalSymbol)
    const globalSymbol = symbols[symbolId] || defaultSymbol
    const { accountId } = useSelector(state => state.accountSummary)
    const [tvWidget, setTvWidget] = useState()
    const orderSLTP = useSelector(state => state.orderPosition.orderSLTP);
    const positions = useSelector((state) => state.orderPosition.positions);
    const orders = useSelector((state) => state.orderPosition.orders);
    const { t } = useTranslation()
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const username = getCookies('username')

    const convertResolution = (tradingViewResolution) => {
        const resolutionsMap = { '1': '1', '5': '2', '15': '3', '30': '4', '60': '5', '240': '6', '1D': '7', '1W': '8', '1M': '9' };
        return resolutionsMap[tradingViewResolution] || null;
    }
    const dispatch = useDispatch();

    useEffect(() => {

        if (!window.TradingView) {
            console.error("❌ TradingView library not loaded!");
            return;
        }
        if (!chartContainerRef.current) return;
        if (!globalSymbol?.name) {
            return;
        }
        // if (!tvWidget) {
        const datafeed = {
            onReady: (callback) => {
                setTimeout(() => { callback(configurationData) }, 0);
            },
            searchSymbols: async (userInput, exchange, symbolType, onResultReadyCallback) => {
                const searchSymbols = Object.values(symbols)
                if (searchSymbols.length > 0) {
                    const filteredSymbols = searchSymbols.filter((symbol) => {
                        return symbolType && symbolType !== 'all'
                            ? symbol.description.toLowerCase() === symbolType.toLowerCase() &&
                            symbol.name.toLowerCase().includes(userInput.toLowerCase())
                            : symbol.name.toLowerCase().includes(userInput.toLowerCase())
                    }
                    );
                    const symbolsResult = filteredSymbols.map((symbol) => ({
                        symbol: symbol.name,
                        full_name: symbol.name,
                        description: symbol.description,
                        exchange: '',
                        ticker: symbol.name,
                        type: symbol.description,
                    }));
                    onResultReadyCallback(symbolsResult);
                }
            },
            resolveSymbol: async (symbolName, onSymbolResolvedCallback, onResolveErrorCallback,) => {
                const symbol = Object.values(symbols).find(item => item.name === symbolName)
                const symbolInfo = {
                    symbol: symbol?.name,
                    name: symbol?.name,
                    id: symbol?.id,
                    full_name: symbol?.name,
                    description: symbol?.name,
                    timezone: 'UTC',
                    session: "27x7",
                    ticker: symbol?.name,
                    minmov: 1,
                    pricescale: 100000,
                    has_intraday: true,
                    has_daily: true,
                    has_weekly_and_monthly: true,
                    supported_resolutions: configurationData.supported_resolutions,
                    data_status: 'streaming',
                    exchange: '',
                    listed_exchange: '',
                    format: 'price',
                }

                dispatch(setGlobalSymbolsData(symbol))
                dispatch(setGlobalSymbolID(symbol?.id))

                // dispatch(setSymbol({ symbolId: symbol?.id, symbolName: symbol?.name, bid: symbol?.bid, ask: symbol?.ask }));
                setTimeout(() => { onSymbolResolvedCallback(symbolInfo); }, 0);
            },
            getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
                const symbol = Object.values(symbols).find(item => item?.name === symbolInfo?.name)
                const { from, to, firstDataRequest } = periodParams;
                const periodParam = convertResolution(resolution);
                if (!periodParam) {
                    console.error("[getBars]: Invalid resolution provided", resolution);
                    onErrorCallback("Invalid resolution");
                    return;
                }
                const symbolId = symbol?.id || globalSymbol?.id;
                if (!symbolId) {
                    console.warn("[getBars]: No symbolId found, returning no data");
                    onHistoryCallback([], { noData: true });
                    return;
                }
                console.log('from', to, new Date(to * 1000))
                const requestBody = { clientId: userDetail?.id?.toString(), symbolId: symbolId.toString(), period: Number(periodParam), unixFrom: from, unixTo: to };
                // const requestBody = { clientId: userDetail?.id?.toString(), symbolId: symbolId.toString(), period: Number(periodParam), from: new Date(from * 1000).toISOString(), to: new Date(to * 1000).toISOString() };
                try {
                    const { data } = await getChartHistoryData(requestBody)
                    if (data.length === 0 && (resolution === '1' || resolution === '5')) {
                        // If the resolution is 1 or 5 and there's no data, fetch the last 24 hours
                        let HasData = false;
                        for (let i = 0; i <= 4; i++) {
                            let fromDate = from;
                            if (resolution === '1') {
                                fromDate = from - 21600 * i * i;
                            } else {
                                fromDate = from - 21600 * i * 4 * i;
                            }
                            const { data: oldData } = await getChartHistoryData({ ...requestBody, unixFrom: fromDate * 1000 })
                            // const { data: oldData } = await getChartHistoryData({ ...requestBody, from: new Date(fromDate * 1000).toISOString() })
                            if (oldData.length > 0) {
                                HasData = true;
                                if (firstDataRequest) {
                                    const lastData = { ...data[data.length - 1] }
                                    lastBarsCache.set(symbolInfo.full_name, { ...lastData });
                                }
                                const bars = oldData.map(bar => ({ time: bar.time * 1000, open: bar.open, high: bar.high, low: bar.low, close: bar.close, }));
                                onHistoryCallback(bars, { noData: false });
                                break;
                            }
                        }
                        if (!HasData) {
                            onHistoryCallback([], { noData: true });
                        }
                    } else {
                        if (data.length === 0) {
                            onHistoryCallback([], { noData: true });
                        } else {
                            if (firstDataRequest) {
                                const lastData = { ...data[data.length - 1] }
                                lastBarsCache.set(symbolInfo.full_name, { ...lastData });
                            }
                        }
                        const bars = data.map(bar => {
                            console.log()
                            // console.log(new Date('2025-08-06T22:20:00.000Z'))
                            // console.log(bar.dateTime)

                            return { time: bar.time * 1000, open: bar.open, high: bar.high, low: bar.low, close: bar.close, }
                        });
                        onHistoryCallback(bars, { noData: false });
                    }

                } catch (error) {
                    console.error('[getBars]: Error fetching data', error);
                    onErrorCallback(error);
                }
            },
            subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
                const handler = {
                    id: subscriberUID,
                    callback: onRealtimeCallback,
                };
                handlerMap.set(symbolInfo.id, handler);
                let subscriptionItem = channelToSubscription.get(symbolInfo.name);
                if (subscriptionItem) {
                    // Already subscribed to the channel, use the existing subscription
                    subscriptionItem.handlers.push(handler);
                    return;
                }
                subscriptionItem = {
                    subscriberUID,
                    resolution,
                    lastDailyBar: lastBarsCache.get(symbolInfo.name),
                    handlers: [handler],
                };
                channelToSubscription.set(symbolInfo.id, subscriptionItem);
            },
            unsubscribeBars: (subscriberUID) => {
                const currencyPair = subscriberUID.split('_#_')[0];
                handlerMap.delete(currencyPair);
            }
        };
        const accessList = {
            type: 'black',
            tools: [
                { name: 'VWAP', grayed: false },
                { name: '52 Week High/Low', grayed: false },
                { name: 'Heikin Ashi', grayed: false },
            ],
        };
        const widget = new window.TradingView.widget({
            studies_access: accessList,
            autosize: true,
            symbol: globalSymbol?.name || globalSymbol.symbolName,
            interval: "1",
            timezone: "UTC",
            locale: direction === 'rtl' ? 'ar' : 'en',
            range: "12M",
            hide_top_toolbar: false,
            allow_symbol_change: true,
            enable_publishing: false,
            style: "1",
            theme: darkMode ? "dark" : "light",
            container: chartContainerRef.current,
            datafeed: datafeed,
            library_path: "/charting_library_cloned_data/charting_library/",
            studies: ["Moving Average"],
            withdateranges: true,
            hide_side_toolbar: false,
            volumePaneSize: "hide",
            enabled_features: [],
            // overlay: true,
            rtl: direction === 'rtl',
            overrides: {
                "paneProperties.background": darkMode ? "#151924" : "#ffffff",
                "paneProperties.vertGridProperties.color": darkMode ? "#2f3b5b" : "#e6e6e6",
                "paneProperties.horzGridProperties.color": darkMode ? "#2f3b5b" : "#e6e6e6",
                "scalesProperties.textColor": darkMode ? "#D9D9D9" : "#131722",
                "scalesProperties.lineColor": darkMode ? "#444" : "#ccc",
                "scalesProperties.showSymbolLabels": false,
                "mainSeriesProperties.highLowAvgPrice.highLowPriceLabelsVisible": true,
            },
            disabled_features: [
                "use_localstorage_for_settings",
                "popup_hints",
                "volume_force_overlay",
                "create_volume_indicator_by_default"
            ],
        });
        setTvWidget(widget)
        return () => {
            if (widget) {
                widget.remove();
                setTvWidget(undefined);
            }
        };
    }, [globalSymbol, userDetail, direction]);

    const createPositionLine = async (tvWidget, order) => {
        try {
            const chart = tvWidget?.activeChart();
            const orderLine = await chart.createOrderLine();

            orderLine
                .setText(`${order?.side == 1 ? "BUY" : "SELL"} ${(order?.amount).toFixed(decimalPlaces)} at ${(order?.openPrice).toFixed(symbols[order?.symbolId].digits)} #${order?.id}`)
                .setQuantity("")
                .setPrice(order?.openPrice)
                .setLineStyle(0)
                .setLineColor(order?.side == 1 ? '#089981' : '#f23645')
                .setBodyBackgroundColor(order?.side == 1 ? '#F1FAF8' : '#FEEDEE')
                .setBodyBorderColor(order?.side == 1 ? '#089981' : '#f23645')
                .setBodyTextColor(order?.side == 1 ? '#089981' : '#f23645')
                .setLineLength(100)
                .setCancelButtonIconColor(order?.side == 1 ? '#089981' : '#f23645')
                .setCancelButtonBackgroundColor(order?.side == 1 ? '#F1FAF8' : '#FEEDEE')
                .setCancelButtonBorderColor(order?.side == 1 ? '#089981' : '#f23645')
                .setCancelTooltip("Close Position")
                .onCancel(async () => {
                    try {
                        const closeOrderPayload = {
                            accountId: Number(accountId),
                            positionId: order?.id,
                            amount: order?.amount,
                        };
                        const { data } = await closeOrderPosition(closeOrderPayload);

                        const line = orderLineMap.get(order.id);
                        if (line) {
                            line.remove();
                            orderLineMap.delete(order.id);
                        }
                        dispatch(deletePositionsData(order.id));

                        const symbolName = symbols[order?.symbolId]?.name || order?.symbolName || '';
                        const side = order?.side === 1 ? 'BUY' : 'SELL';
                        const price = order?.openPrice;
                        addJournalLog('tradeClosed', `Trade closed: ID #${order?.id}, ${symbolName}, at ${price}, ${side}, Amount: ${order?.amount}, Account ${username}: ${accountId}.`);
                        // toast.success(`Closed Trade #${order?.id} (${symbolName}) at ${price}, ${tradeSide}`);
                    } catch (err) {
                        toast.error(err?.response?.data?.message);
                    }
                });

            // ✅ Store reference in map
            orderLineMap.set(order.id, orderLine);

            return orderLine;
        } catch (err) {
            console.log(err);
        }
    };
    const getPendingOrderLabel = (side, amount, price, orderId) => {
        let label = "-";

        // eslint-disable-next-line default-case
        switch (side) {
            case 1:
                label = t("BuyLimit");
                break;
            case -1:
                label = t("SellLimit");
                break;
            case 2:
                label = t("BuyStop");
                break;
            case -2:
                label = t("SellStop");
                break;
        }

        if (price == null || isNaN(price)) return null;

        return `${label} ${amount.toFixed(decimalPlaces) ?? '-'} at ${price} #${orderId}`;
    };

    const createPendingOrderLine = async (tvWidget, order) => {
        try {
            const chart = tvWidget?.activeChart();
            const pendingLine = await chart.createOrderLine();
            const label = getPendingOrderLabel(order?.side, order?.amount, order?.price, order?.id);
            pendingOrderLineMap.get(order?.id)?.remove();
            const orderPrice = order?.price
            if (!label) return;
            pendingLine
                .setText(`PENDING ${label}`)
                .setQuantity("")
                .setPrice(order?.price)
                // .setLineStyle(1)
                .setLineColor(order?.side === 1 ? '#4CAF50' : '#FF5722')
                .setBodyBackgroundColor(order?.side === 1 ? '#E8F5E9' : '#FFF3E0')
                .setBodyBorderColor(order?.side === 1 ? '#4CAF50' : '#FF5722')
                .setBodyTextColor(order?.side === 1 ? '#4CAF50' : '#FF5722')
                .setLineLength(100)
                .setCancelButtonIconColor(order?.side === 1 ? '#4CAF50' : '#FF5722')
                .setCancelButtonBackgroundColor(order?.side === 1 ? '#E8F5E9' : '#FFF3E0')
                .setCancelButtonBorderColor(order?.side === 1 ? '#4CAF50' : '#FF5722')
                .onCancel(async () => {
                    try {
                        const payload = { accountId: Number(accountId), id: order.id };
                        const response = await closeOrder(payload);
                        const message = response?.data?.message || response?.message || "";

                        if (response.status === 200) {
                            // toast.success(message || `Pending order #${order.id} closed successfully.`);
                            pendingOrderLineMap.delete(order.id);
                            dispatch(deleteOrdersData(order.id));
                        } else {
                            toast.error(message || "Failed to close pending order.");
                        }
                    } catch (err) {
                        console.error("Failed to cancel pending order:", err);
                        toast.error(`Cancel failed: ${err?.response?.data?.message || err.message}`);
                        addJournalLog("cancelOrderError", `Pending order #${order.id} cancel failure. Account ${username}: ${accountId}.`);
                    }
                })
                .onMove(async (price) => {
                    try {
                        const updatedPrice = pendingLine.getPrice();
                        const payload = {
                            id: order?.id,
                            accountId: order?.accountId,
                            price: updatedPrice,
                            amount: order?.amount,
                            comment: order?.comment,
                        };

                        const response = await modifyOrder(payload);

                        if (response?.status === 200) {
                            // toast.success(`Order updated: ID #${order?.id} ${symbols[order?.symbolId]?.name} at ${response.data.price}, Amount: ${response.data.amount}`);
                        } else {
                            toast.error("Failed to update pending order");
                        }
                    } catch (err) {
                        toast.error(err?.response?.data?.message || "Failed to update pending order");
                        pendingLine.setPrice(orderPrice)
                    }
                });


            pendingOrderLineMap.set(order.id, pendingLine);
            return pendingLine;
        } catch (err) {
            console.error("Error creating pending order line", err);
        }
    };
    const createSLTPLine = async (tvWidget, order, type) => {
        try {
            const chart = tvWidget?.activeChart();
            const sltpLine = await chart.createOrderLine();

            const isSL = type === 'SL';
            const price = isSL ? order?.stopLoss : order?.takeProfit;
            if (price === null || price === undefined) return;
            const slPrice = order?.stopLoss;
            const tpPrice = order?.takeProfit
            sltpLine
                .setText(`${type} ${order?.amount} at ${price.toFixed(symbols[order?.symbolId].digits)} #${order?.id}`)
                .setQuantity("")
                .setPrice(price)
                .setLineColor(isSL ? '#f23645' : '#089981')
                .setBodyBackgroundColor(isSL ? '#FEEDEE' : '#F1FAF8')
                .setBodyBorderColor(isSL ? '#f23645' : '#089981')
                .setBodyTextColor(isSL ? '#f23645' : '#089981')
                .setLineLength(100)
                .setCancelButtonIconColor(isSL ? '#f23645' : '#089981')
                .setCancelButtonBackgroundColor(isSL ? '#FEEDEE' : '#F1FAF8')
                .setCancelButtonBorderColor(isSL ? '#f23645' : '#089981')
                .onCancel(async () => {
                    try {
                        const payload = { accountId: Number(accountId), id: order.id };
                        const response = await deleteSLTPOrders(payload);
                        const message = response?.data?.message || response?.message || "";

                        if (response.status === 200) {
                            dispatch(deleteOrdersData(order.id));
                            // toast.success(message || `${type} removed for order #${order.id}`);
                            sltpLineMap.delete(`${order.id}_${type}`);
                            sltpLine.remove();
                        } else {
                            toast.error(message || `Failed to delete ${type}`);
                        }
                    } catch (err) {
                        console.error(`Failed to delete ${type}:`, err);
                        toast.error(`Delete ${type} failed: ${err?.response?.data?.message || err.message}`);
                        addJournalLog("cancelOrderError", `SLTP ${type} cancel failure: Order #${order.id}, Account ${username}: ${accountId}`);
                    }
                })
                .onMove(async (event) => {
                    try {
                        const updatedPrice = sltpLine.getPrice();
                        const isSL = type?.toUpperCase() === 'SL';
                        console.log(updatedPrice,);
                        if (!updatedPrice || isNaN(updatedPrice)) {
                            console.warn("Invalid price:", price);
                            toast.error(`Invalid ${type} price`);
                            return;
                        }

                        const updatedOrder = {
                            id: order.id,
                            amount: order.amount,
                            ...(isSL ? { stopLoss: updatedPrice, takeProfit: tpPrice } : { takeProfit: updatedPrice, stopLoss: slPrice }),
                            accountId: order.accountId
                        };

                        const response = await updateSLTPOrders(updatedOrder);

                        if (response?.status === 200) {
                            dispatch(editSLTPOrder(response));
                            // toast.success(`${type} updated successfully`);
                        } else {
                            toast.error(`Failed to update ${type}`);
                        }
                    } catch (err) {
                        console.error(`Error updating ${type}`, err);
                        type?.toUpperCase() === 'SL' ? sltpLine.setPrice(slPrice) : sltpLine.setPrice(tpPrice);
                        toast.error(err?.response?.data?.message || `Failed to update ${type} price`);
                    }
                });
            sltpLineMap.set(`${order.id}_${type}`, sltpLine);
            return sltpLine;
        } catch (err) {
            console.error(`Error creating ${type} line`, err);
        }
    };
    function removeAllOrderLines() {
        for (const line of orderLineMap.values()) {
            line.remove?.();
        }
        orderLineMap.clear();

        for (const line of pendingOrderLineMap.values()) {
            console.log("line remove")
            line.remove?.();
        }
        pendingOrderLineMap.clear();

        for (const line of sltpLineMap.values()) {
            line.remove?.();
        }
        sltpLineMap.clear();
    }
    useEffect(() => {
        if (!tvWidget) return;
        tvWidget?.changeTheme?.(darkMode ? "dark" : "light");
    }, [darkMode]);

    useEffect(() => {
        if (!tvWidget) return;
        removeAllOrderLines();
        tvWidget.onChartReady(() => {
            const openPositions = positions.filter(position => position.symbolId === globalSymbol.id);
            openPositions?.map(item => {
                return createPositionLine(tvWidget, item)
            })
            const openPositionsLine = orders.filter(order => order.symbolId === globalSymbol.id);

            openPositionsLine.forEach(async (position) => {
                await createPendingOrderLine(tvWidget, position);
            });

            const sltpOrders = orderSLTP.filter(sltp => sltp.symbolId === globalSymbol.id);
            console.log(sltpOrders, "--------------------------sltpOrders")
            sltpOrders.forEach(order => {
                if (order.stopLoss) createSLTPLine(tvWidget, order, 'SL');
                if (order.takeProfit) createSLTPLine(tvWidget, order, 'TP');
            });

        })
        return () => {
            removeAllOrderLines();
        }
    }, [globalSymbol, positions, tvWidget, orderSLTP, orders])

    return (
        <div style={{ height: "100%", width: "100%" }} >
            <div ref={chartContainerRef} style={{ height: "100%", width: "100%", backgroundColor: darkMode ? "#151924" : "#ffffff" }}></div>
        </div>
    );

};

export default TradingViewChart;